import React from "react";
import { Form, Select } from "antd";
const { Option } = Select;
const YesOrNoToggleInput = ({ name, label, disabled }) => (React.createElement(Form.Item, { name: name, label: label },
    React.createElement(Select, { disabled: disabled },
        React.createElement(Option, { key: "yes", value: true }, "Yes"),
        React.createElement(Option, { key: "no", value: false }, "No"))));
export default YesOrNoToggleInput;
